// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { TicketCus } from '@tectonics/look-and-feel/volcanes/pages/page-confirmed-payment/page-content/achpse-page/ticket-cus';
import { TicketId } from '@tectonics/look-and-feel/volcanes/pages/page-confirmed-payment/page-content/achpse-page/ticket-id';
import { TicketBankName } from '@tectonics/look-and-feel/volcanes/pages/page-confirmed-payment/page-content/achpse-page/ticket-bank-name';

export function TicketDetails(): Node {
  return (
    <Table>
      <tbody>
        <tr>
          <td>Estado</td>
          <td>Aprobado</td>
        </tr>
        <tr>
          <td>Ticket ID</td>
          <TicketId />
        </tr>
        <tr>
          <td>CUS</td>
          <TicketCus />
        </tr>
        <tr>
          <td>Banco</td>
          <TicketBankName />
        </tr>
      </tbody>
    </Table>

  );
}

const Table = styled.table`
  width: 100%;
  padding: 20px;
  border: 1px solid #c5c5c5;
  td {
    padding-bottom: 10px;
  }
  tr td:first-child {
    font-weight: 600;
    text-align: left;
  }
  tr td:last-child {
    color: #7f7f7f;
    text-align: right;
  }
  tr:last-child {
    td {
      padding-bottom: 0;
    }
  }
`;
